import { render } from "./HeadTitle.vue?vue&type=template&id=1e68602f&scoped=true&ts=true"
import script from "./HeadTitle.vue?vue&type=script&lang=ts"
export * from "./HeadTitle.vue?vue&type=script&lang=ts"

import "./HeadTitle.vue?vue&type=style&index=0&id=1e68602f&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e68602f"]])

export default __exports__